export default __webpack_public_path__ + "static/media/iDocCarFont.19391543.ttf";